export default {"src":"/_next/static/media/camma.7c4eaa9e.svg","height":31,"width":39,"blurWidth":0,"blurHeight":0};